import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BANNER_COLORS, BANNER_HEIGHTS, STAR_PATTERN_SVG } from './constants';

/**
 * Main banner container with full-width layout and responsive height
 * - Mobile: 600px height for vertical content layout
 * - Desktop: 190px height for horizontal content layout
 */
export const BannerContainer = styled(Box)(({ theme }) => ({
  // Layout
  width: '99.6vw',
  marginLeft: 'calc(-50vw + 50%)',
  marginRight: 'calc(-50vw + 50%)',
  marginBottom: theme.spacing(2),
  position: 'relative',
  overflow: 'hidden',

  // Responsive height
  height: BANNER_HEIGHTS.MOBILE,

  // Spacing
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  paddingLeft: 0,
  paddingRight: 0,

  // Background styling
  backgroundImage: BANNER_COLORS.GRADIENT,
  backgroundRepeat: 'no-repeat',

  // Decorative background shape (dark overlay)
  '&::before': {
    content: '""',
    position: 'absolute',
    // Mobile styles
    top: '60%',
    left: '20%',
    width: '473px',
    height: '427px',
    background: theme.palette.common.black,
    borderRadius: '90px',
    transform: 'translate(-50%, -50%) rotate(12.5deg)',
    zIndex: 1,

    // Desktop styles
    [theme.breakpoints.up('md')]: {
      top: '40%',
      left: '10%',
      width: '1261px',
      height: '345px',
    },
  },

  // Decorative star pattern
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '20%',
    left: '25%',
    width: '100%',
    height: '100%',
    backgroundImage: STAR_PATTERN_SVG,
    backgroundRepeat: 'no-repeat',
    zIndex: 2,
  },

  // Desktop styles
  [theme.breakpoints.up('md')]: {
    height: BANNER_HEIGHTS.DESKTOP,
    maxHeight: BANNER_HEIGHTS.DESKTOP_MAX_HEIGHT,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));
